<template>
  <article class="">
    <div class="table_card">
      <div class="table_card__head">
        <v-flex lg10 class="table_card__head--sections">
          <p class="table_card__head--title">
            Búsqueda de usuario
          </p>
        </v-flex>
        <v-flex
          lg2
          class="filter_options table_card__head--sections"
          v-show="visible"
        >
          <div
            class="ticket_list__refresh_button faccess_button"
            @click="$emit('invisible')"
          >
            Registrar Usuario
          </div>
        </v-flex>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form
              onSubmit="return false;"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-layout row wrap style="background-color: #fff; padding: 0px;">
                <v-flex xs6>
                  <input
                    v-model="rut"
                    placeholder="Ingrese el documento del usuario"
                    required
                    class="input_solid"
                    style="width: 98% !important"
                  />
                  <img
                    src="@/assets/img/icons/search-icon.svg"
                    class="button_search"
                    style="margin-left: -55px"
                  />
                </v-flex>
                <v-flex xs6 class="pl-2">
                  <button
                    type="button"
                    class="faccess_button px-5"
                    @click="findTicketsByRut()"
                    :disabled="!valid || searching_rut == ''"
                  >
                    Consultar
                  </button>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <section class="ticket_list" v-if="tickets.length > 0">
          <p class="ticket_list__title">Tickets</p>
          <section
            v-for="(ticket, i) in tickets"
            :key="ticket.id"
            @click="
              showTicket(
                ticket.ticket_type,
                getUserId(),
                ticket.rut,
                ticket.consecutive
              )
            "
            class="ticket_list__container"
          >
            <div>Ticket {{ i + 1 }}</div>
            <section class="ticket_list__container--data">
              <div class="ticket_list__section">
                <div class="ticket_list__section--icon">
                  <v-icon dark v-text="'print'"></v-icon>
                </div>
                <div class="ticket_list__section--text-container">
                  <p class="ticket_list__section--title">
                    {{ ticket.name }}
                  </p>
                  <p class="ticket_list__section--subtitle">
                    {{ ticket.email }}
                  </p>
                </div>
              </div>
            </section>
          </section>
        </section>
        <section class="ticket_list" v-else-if="bookings.length > 0">
          <p class="ticket_list__title">Reservas</p>
          <section
            v-for="ticket in bookings"
            :key="ticket.id"
            @click="
              new Date().getTime() >= new Date(ticket.start_time).getTime()
                ? showBookingAccess(ticket.user_id, ticket.uuid)
                : null
            "
            class="ticket_list__container"
          >
            <div class="ticket_list__section">
              <div class="ticket_list__section--icon">
                <v-icon dark v-text="'print'"></v-icon>
              </div>
              <div class="ticket_list__section--text-container">
                <p class="ticket_list__section--title">
                  {{
                    `${new Date(ticket.start_time).getHours()}:${
                      new Date(ticket.start_time).getMinutes() < 10
                        ? "0" + new Date(ticket.start_time).getMinutes()
                        : new Date(ticket.start_time).getMinutes()
                    }-${new Date(ticket.end_time).getHours()}:${
                      new Date(ticket.end_time).getMinutes() < 10
                        ? "0" + new Date(ticket.end_time).getMinutes()
                        : new Date(ticket.end_time).getMinutes()
                    }`
                  }}
                </p>
                <p
                  class="ticket_list__section--subtitle"
                  v-if="
                    new Date().getTime() < new Date(ticket.start_time).getTime()
                  "
                >
                  Fuera del horario de impresión
                </p>
              </div>
            </div>
          </section>
        </section>
        <section v-else>
          <p class="ticket_list__section--subtitle">
            El usuario no tiene acceso a ninguna de las locaciones
          </p>
        </section>
      </div>
    </div>

    <section class="modal_info" v-if="show_ticket && qr_string != null">
      <section
        class="modal_info__modal"
        style="height:fit-content;border-radius:5px; max-width: 400px;"
      >
        <div class="qr_content" ref="qr_content">
          <vue-qrcode
            id="print"
            errorCorrectionLevel="L"
            class="qr_content__qr"
            :value="qr_string"
            v-for="n in 4"
            :key="n"
          ></vue-qrcode>
        </div>
        <div
          id="noprint"
          class="modal_info__modal__buttons"
          style="position: static!important"
          v-show="notPrint"
        >
          <button
            class="modal_info__modal__buttons--cancel"
            @click="cancelTicket()"
          >
            Cancelar
          </button>
          <button
            class="modal_info__modal__buttons--confirm"
            @click="printTicket()"
          >
            Imprimir Ticket
          </button>
        </div>
        <div
          class="modal_info__modal__noprint"
          v-show="printMessage"
          id="noprint"
        >
          Abriendo configuracion de impresión, esto puede tardar unos
          segundos...
        </div>
      </section>
    </section>
  </article>
</template>

<script>
export default {
  data() {
    return {
      qr_string: null,
      show_ticket: true,
      rut: "",
      searching_rut: "",
      rules: {
        required: value => !!value || "Requerido."
      },
      user_finded: false,
      valid: false,
      tickets: [],
      bookings: [],
      isOnLine: true,
      notPrint: true,
      printMessage: false
    };
  },
  watch: {
    rut() {
      this.searching_rut = this.rut.toUpperCase();
      this.rut = this.searching_rut;
    }
  },
  methods: {
    async findTicketsByRut() {
      if (!window.eel) {
        this.$http
          .get("app/bookings/search_active_tickets", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              user_type: this.getUserType(),
              rut: this.searching_rut,
              user_id: this.getUserId()
            }
          })
          .then(function(response) {
            if (this.getUserType() == "Booking_office") {
              this.isOnLine = true;
            }
            console.log("Success");
            console.log(response);
            console.log(response.body);
            this.tickets = response.body.tickets;
            this.bookings = response.body.bookings.filter(
              ticket =>
                new Date().getDay() == new Date(ticket.start_time).getDay()
            );
          })
          .catch(async e => {
            if (this.getUserType() == "Booking_office") {
              if (e.status == 0) {
                this.isOnLine = false;
              }
              let fs = window.require("fs");
              let qrs = await fs.readFileSync(
                `${window.__dirname}/../../db/data.txt`,
                "utf-8"
              );
              qrs = qrs.split("\n");
              let encryRut = this.encrypt(this.searching_rut);
              this.tickets = qrs
                .filter(qr => {
                  let [, , qrEncryRut] = qr.split(".");
                  return qrEncryRut == encryRut;
                })
                .map((qr, i) => {
                  let [qrType, , qrEncryRut, qrConsecutive] = qr.split(".");
                  return {
                    id: i,
                    ticket_type: qrType,
                    rut: qrEncryRut,
                    name: "Offline",
                    email: "Offline",
                    consecutive: qrConsecutive
                  };
                });
            }
          });
      } else {
        this.isOnLine = true;
        let ticketGroup = await window.eel.search_user_tickets(
          this.searching_rut
        )();
        if (ticketGroup) {
          let ticketList = ticketGroup[1];
          this.tickets = [];
          let qrType = 3;
          let index = 1;
          ticketList.map(ticketJson => {
            for (let i = 0; i < ticketJson.uses; i++) {
              index++;
              this.tickets.push({
                id: index,
                ticket_type: qrType,
                rut: ticketJson.identification_number,
                name: ticketJson.full_name,
                email: ticketJson.email,
                consecutive: 1
              });
            }
          });
        }
      }
    },
    showTicket(ticket_type = 3, booking_officer_id, user_rut, consecutive) {
      let time_send = new Date().getTime();
      this.qr_string =
        "<" +
        ticket_type.toString() +
        "." +
        this.encrypt(booking_officer_id) +
        "." +
        (this.isOnLine ? this.encrypt(user_rut) : user_rut) +
        "." +
        consecutive.toString() +
        "." +
        time_send +
        ">";
      console.log(this.qr_string);
      this.show_ticket = true;
    },
    showBookingAccess(us_id, uuid) {
      let time_send = new Date().getTime();
      let devId = this.buildDeviceId();
      let devIdLen = devId.length;
      // devId = "ticketAccessBooking"+ + this.buildDeviceId();
      devId =
        "ticAccessBook" + time_send.toString().slice(-4) + this.buildDeviceId();
      devId = devId.slice(0, devIdLen);
      this.qr_string =
        "<-" +
        this.encrypt(us_id + "//" + time_send + "//" + devId).toString() +
        "." +
        uuid +
        ">";
      // console.log(this.qr_string);
      this.show_ticket = true;
    },
    cancelTicket() {
      this.qr_string = null;
      this.show_ticket = false;
    },
    printTicket() {
      this.notPrint = false;
      this.printMessage = true;
      setTimeout(() => {
        window.print();
      }, 1);
      window.onafterprint = () => {
        this.printMessage = false;
        this.notPrint = true;
      };
    }
  },
  mounted() {
    console.log(this.$route);

    console.log("this.documentNumber", this.documentNumber);
    if (this.getUserType() == "Booking_office") {
      this.rut = this.documentNumber;
      this.searching_rut = this.documentNumber;
      this.isOnLine = navigator.onLine;
      if (this.searching_rut) {
        this.findTicketsByRut();
      }
    }
    if (this.$route.params != null && this.$route.params.rut) {
      console.log("Con parametros");
      this.rut = this.$route.params.rut
        ? this.$route.params.rut
        : this.documentNumber;
      this.searching_rut = this.$route.params.rut
        ? this.$route.params.rut
        : this.documentNumber;
      if (this.searching_rut) {
        this.findTicketsByRut();
      }
    } else {
      console.log("sin parametros");
    }
  },
  props: ["visible", "documentNumber"]
};
</script>



// WEBPACK FOOTER //
// src/components/views/bookingOffice/GenerateQr.vue